import { StyleSheet } from 'react-native';

export const highChartPieStyling = theme => {
  return StyleSheet.create({
    container: {
      position: 'relative'
    },
    centerLabelContainer: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
    centerLabelSublabelContainer: {
      marginTop: 20
    }
  });
};
